import React from 'react';
import { PropTypes } from 'prop-types';
import EmptyCard from '../../components/EmptyCard';
import Card from '../../components/Card';
import AddInfo from '../../components/AddInfo';
import styles from './OrderInfo.css';

const ShippingInfo = ({
  shippingInfo: { city, state, street1, postalCode },
  onEditShipping,
  hasShippingInfo,
}) =>
  !hasShippingInfo ? (
    <EmptyCard title="Shipping" titleCentered>
      <AddInfo onClick={onEditShipping} />
    </EmptyCard>
  ) : (
    <Card title="Shipping Address" onEdit={onEditShipping}>
      <p className={styles.pStyles}>
        <strong>{street1}</strong>
      </p>
      <hr className={styles.hrStyles} />
      <p className={styles.pStylesSmall}>
        {city}, {state} {postalCode}
      </p>
    </Card>
  );

ShippingInfo.propTypes = {
  shippingInfo: PropTypes.object,
  onEditShipping: PropTypes.func.isRequired,
  hasShippingInfo: PropTypes.bool.isRequired,
};

export default ShippingInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/ShippingInfo.jsx